module.exports = __webpack_public_path__ + "static/media/img1.d9e94e58.png";